import {useScrollServiceToken} from '@/di/di.root-container.hooks';

import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

export function ScrollToTop(): null {
  const {pathname} = useLocation();
  const scrollService = useScrollServiceToken();

  useEffect(() => {
    scrollService.scrollPageToTop();
  }, [pathname]);

  return null;
}
